import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import NewClientUser from "../components/Admin/ClientUser/NewClientUser";

function NewClientUserPage () {
    return(
        <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={false} />
                </div>
              <div className="content-class">
              <NewClientUser />
              </div>
              <div className="footer-class">
                  <Footer />
              </div>
            </div>
        </div>
        </>
    )
}

export default NewClientUserPage;